var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.toggleColormap()}}},[_c('div',{staticClass:"icon-stack"},[_c('i',{staticClass:"fas fa-tint fa-flip-horizontal background",class:{'white-on-black': _vm.whiteOnBlack}}),_c('i',{staticClass:"fas fa-tint fa-flip-horizontal foreground",class:{'white-on-black': _vm.whiteOnBlack}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }